/**
 * @generated SignedSource<<b65ffb2cd4cfbd5bb1f78692539f69ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type leadDetails_root$data = {
  readonly me: {
    readonly isAdmin: boolean | null;
    readonly modules: ReadonlyArray<string>;
  } | null;
  readonly tenantSettings: {
    readonly activateLandRegistryOwners: boolean;
    readonly id: string;
    readonly showAdditionalLinks: boolean;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"LeadDetailsLatestAppraisalCard_root" | "leadBrokerCard_root" | "leadControls_root" | "propertyCard_root">;
  readonly " $fragmentType": "leadDetails_root";
};
export type leadDetails_root$key = {
  readonly " $data"?: leadDetails_root$data;
  readonly " $fragmentSpreads": FragmentRefs<"leadDetails_root">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "leadDetails_root",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "propertyCard_root"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "leadBrokerCard_root"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "leadControls_root"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LeadDetailsLatestAppraisalCard_root"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "modules",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAdmin",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Tenant",
      "kind": "LinkedField",
      "name": "tenantSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showAdditionalLinks",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activateLandRegistryOwners",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c6c9c483f5330a7b16b2c448f9939f25";

export default node;
